import React from 'react'

import __uniqueId from 'lodash/uniqueId'

import { FormControl } from '../FormElements/FormControl'
import { FormHelperText } from '../FormElements/FormHelperText'
import { InputLabel } from './InputLabel'
import { Textarea } from './Textarea'
import type { TextareaFieldProps } from './types'

export const TextareaField = React.forwardRef<HTMLTextAreaElement, TextareaFieldProps>(function TextareaField(
  { className, label, id, isLabelHighlighted = false, error = false, helperText, required = false, ...inputProps },
  ref
) {
  const inputId = id || __uniqueId('textarea-field-')

  return (
    <FormControl className={className} error={error}>
      {label && (
        <InputLabel htmlFor={inputId} required={required} error={Boolean(error)} highlighted={isLabelHighlighted}>
          {label}
        </InputLabel>
      )}
      <Textarea
        aria-describedby={helperText ? `${inputId}-helper-text` : undefined}
        aria-invalid={Boolean(error)}
        error={Boolean(error)}
        id={inputId}
        ref={ref}
        required={required}
        {...inputProps}
      />
      {helperText && (
        <FormHelperText id={`${inputId}-helper-text`} aria-live="polite">
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
})

TextareaField.displayName = 'TextareaField'
